import { Link } from "react-router-dom";

const GraphqlExplorerHeader = ({specificationLink}) => {
    
    return (
        <>
            <div className="graphiql-explorer-information-box">
                <div className="certification-alert">
                    <span className="certification-alert__icon material-icons-outlined">info</span>
                    <div className="certification-alert__message">
                        <p>
                        A valid certificate is required to authenticate the APIs
                        <br />
                        <Link to="https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html" target="_blank">Request a trial</Link> or see how to <Link to="/documentation#request-in-portal">install your certificate</Link>
                        </p>
                    </div>
                </div>
                <div className="certification-alert">
                    <i className="certification-alert__icon material-icons material-icons-outlined">help_outline</i>
                    <div className="certification-alert__message">
                        <p><Link to={specificationLink} id="specification-link" target="_blank">GraphQL Schema Definition</Link></p>
                    </div>
                </div>
                <div className="graphiql-explorer-documentation">
                    <i className="certification-alert__icon material-icons material-icons-outlined">info</i>
                    <p>Find out more in our <Link to="/documentation#graphql-interface">GraphQL interface documentation</Link></p>
                </div>
            </div>
        </>
    );
};

export default GraphqlExplorerHeader;